import { useCallback, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import history from '../services/history';
import { selectStressById } from '../services/stress';
import selectEcoById from '../services/ecodoppler';
import generateCongTXTPDF from '../pages/laudo/eco/generateCongTXTPDF';

// provavelmente vou remover ou mudar esse hook. tá zoado!
const useLaudoHandlers = () => {
  const [loadingAtividadeId, setLoadingAtividadeId] = useState(null);

  const runWithAtividadeLoading = useCallback(async (atividade, fn) => {
    setLoadingAtividadeId(atividade.CODLAUDO);
    try {
      return await fn();
    } finally {
      setLoadingAtividadeId(null);
    }
  }, []);

  const handleEcg = useCallback(atividade => {
    if (atividade.GUIA1 === 'SIM') {
      history.push(`/reportEcg/${atividade.CODLAUDO}`);
    } else {
      toast.warn('Laudo não liberado!');
    }
  }, []);

  const handleHolter = useCallback(atividade => {
    if (atividade.GUIA1 === 'SIM') {
      history.push(`/reportHolter/${atividade.CODLAUDO}`);
    } else {
      toast.warn('Laudo não Liberado para Internet!');
    }
  }, []);

  const handleStress = useCallback(atividade => {
    if (atividade.GUIA1 !== 'SIM') return toast.warn('Laudo não liberado!');
    history.push('/formStress', { codLaudo: atividade.CODLAUDO });
  }, []);

  const handleTrans = useCallback(atividade => {
    if (atividade.GUIA1 !== 'SIM') return toast.warn('Laudo não liberado!');
    history.push(`/report-trans/${atividade.CODLAUDO}`);
  }, []);

  const handleErgo = useCallback((atividade, printing = false) => {
    history.push({
      pathname: `/reportErgo/${atividade.CODLAUDO}`,
      state: { printing },
    });
  }, []);

  const handleEco = useCallback(
    async (atividade, printing = false) => {
      if (atividade.GUIA1 !== 'SIM') return toast.warn('Laudo não liberado!');

      await runWithAtividadeLoading(atividade, async () => {
        try {
          const eco = await selectEcoById(atividade.CODLAUDO);
          if (eco && eco.TIPOECO === 'EcoC') {
            if (eco.CODREALIZOU === 4860) {
              await generateCongTXTPDF(
                eco,
                printing ? 'imprimirTimbrado' : 'imprimirNormal',
                1
              );
            } else {
              history.push({
                pathname: `/reportEcoCongenito/${atividade.CODLAUDO}`,
                state: { printing },
              });
            }
          } else {
            history.push({
              pathname: `/reportDoppler/${atividade.CODLAUDO}`,
              state: { printing },
            });
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.error || 'Erro ao carregar laudo!'
          );
        }
      });
    },
    [runWithAtividadeLoading]
  );

  const handleEcoTXT = useCallback(
    async atividade => {
      if (atividade.GUIA1 !== 'SIM') return toast.warn('Laudo não liberado!');

      await runWithAtividadeLoading(atividade, async () => {
        try {
          const eco = await selectEcoById(atividade.CODLAUDO);
          if (eco && eco.TIPOECO === 'EcoC') {
            await generateCongTXTPDF(eco, 'imprimirTimbrado', 1);
          } else {
            toast.warn('Disponível para Laudo de Eco Congênito!');
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.error || 'Erro ao carregar laudo!'
          );
        }
      });
    },
    [runWithAtividadeLoading]
  );

  const handleEspelhoDoppler = useCallback(
    async atividade => {
      await runWithAtividadeLoading(atividade, async () => {
        try {
          const eco = await selectEcoById(atividade.CODLAUDO);
          if (eco && eco.TIPOECO === 'EcoD') {
            history.push(`/espelhoDoppler/${atividade.CODLAUDO}`);
          } else if (eco && eco.TIPOECO === 'EcoC') {
            if (eco.CODREALIZOU === 4860) {
              history.push(`/espelhoCongTxt/${atividade.CODLAUDO}`);
            } else {
              history.push(`/espelhoCong/${atividade.CODLAUDO}`);
            }
          } else {
            toast.warn(
              'Espelho Disponível somente para Laudo de Eco Doppler!'
            );
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.error || 'Erro ao carregar laudo!'
          );
        }
      });
    },
    [runWithAtividadeLoading]
  );

  const handleEspelhoFisio = useCallback(
    async atividade => {
      await runWithAtividadeLoading(atividade, async () => {
        try {
          const stress = await selectStressById(atividade.CODLAUDO);
          history.push('/espelhoFisio', { stress });
        } catch (error) {
          toast.error(error.response.data.error);
        }
      });
    },
    [runWithAtividadeLoading]
  );

  const handleEspelhoFarmaco = useCallback(
    async atividade => {
      await runWithAtividadeLoading(atividade, async () => {
        try {
          const stress = await selectStressById(atividade.CODLAUDO);
          history.push('/espelhoFarmaco', { stress });
        } catch (error) {
          toast.error(error.response.data.error);
        }
      });
    },
    [runWithAtividadeLoading]
  );

  const handleEspelhoTrans = useCallback(atividade => {
    history.push(`/espelhoTrans/${atividade.CODLAUDO}`);
  }, []);

  const handleCarotida = useCallback((atividade, printing = false) => {
    if (atividade.GUIA1 !== 'SIM') return toast.warn('Laudo não liberado!');
    history.push({
      pathname: `/report-carotida/${atividade.CODLAUDO}`,
      state: { printing },
    });
  }, []);

  const handleImprimir = useCallback(
    (atividade, printing = false) => {
      switch (atividade.CODPROCEDI) {
        case 1:
        case 58:
        case 800:
          toast.info('Não disponível para impressão!');
          break;
        case 3:
          handleEcg(atividade);
          break;
        case 6:
        case 820:
          handleHolter(atividade);
          break;
        case 7:
        case 810:
          if (atividade.GUIA1 === 'SIM') {
            history.push(`/reportMapa/${atividade.CODLAUDO}`);
          } else {
            toast.warn('Laudo não Liberado para Internet!');
          }
          break;
        case 13:
          handleStress(atividade);
          break;
        case 12:
          handleTrans(atividade);
          break;
        case 4:
          handleErgo(atividade, printing);
          break;
        case 11:
        case 712:
        case 713:
        case 714:
          handleEco(atividade, printing);
          break;
        case 14:
        case 15:
          handleCarotida(atividade, printing);
          break;
        case 17:
          history.push('/form-fetal', { codLaudo: atividade.CODLAUDO });
          break;
        default:
          return toast.warn('Laudo não disponível!');
      }
    },
    [
      handleEcg,
      handleHolter,
      handleStress,
      handleTrans,
      handleErgo,
      handleEco,
      handleCarotida,
    ]
  );

  const handleImprimirTXT = useCallback(
    atividade => {
      switch (atividade.CODPROCEDI) {
        case 11:
        case 712:
        case 713:
        case 714:
          handleEcoTXT(atividade);
          break;
        default:
          return toast.warn('Laudo não disponível para Visualização!');
      }
    },
    [handleEcoTXT]
  );

  const handleImprimirEspelho = useCallback(atividade => {
    switch (atividade.CODPROCEDI) {
      case 12:
        history.push(`/espelhoTrans/${atividade.CODLAUDO}`);
        break;
      case 4:
        history.push(`/espelhoErgo/${atividade.CODLAUDO}`);
        break;
      case 6:
      case 820:
        history.push(`/espelhoHolter/${atividade.CODLAUDO}`);
        break;
      case 7:
        history.push(`/espelhoMapa/${atividade.CODLAUDO}`);
        break;
      case 14:
      case 15:
        history.push({
          pathname: '/espelhoCarotida',
          state: { codLaudo: atividade.CODLAUDO },
        });
        break;
      case 17:
        history.push('/espelhoFetal', { codLaudo: atividade.CODLAUDO });
        break;
      default:
        return toast.warn('Espelho para Laudo ainda não disponível!');
    }
  }, []);

  return useMemo(
    () => ({
      loadingAtividadeId,
      handleEcg,
      handleHolter,
      handleStress,
      handleTrans,
      handleErgo,
      handleEco,
      handleEcoTXT,
      handleEspelhoTrans,
      handleEspelhoDoppler,
      handleEspelhoFisio,
      handleEspelhoFarmaco,
      handleCarotida,
      handleImprimir,
      handleImprimirTXT,
      handleImprimirEspelho,
    }),
    [
      loadingAtividadeId,
      handleEcg,
      handleHolter,
      handleStress,
      handleTrans,
      handleErgo,
      handleEco,
      handleEcoTXT,
      handleEspelhoTrans,
      handleEspelhoDoppler,
      handleEspelhoFisio,
      handleEspelhoFarmaco,
      handleCarotida,
      handleImprimir,
      handleImprimirTXT,
      handleImprimirEspelho,
    ]
  );
};

export default useLaudoHandlers;
